import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LoadingService {
  private _LOADING_COUNT = 0;

  get FULL_LOADING() {
    return this._LOADING_COUNT > 0;
  }

  public startLoading() {
      this._LOADING_COUNT++;
  }

  public stopLoading() {
      this._LOADING_COUNT--;
  }

  public resetLoading() {
      console.error("Memory leak? Você não deveria precisar utilizar esta função.");
      this._LOADING_COUNT = 0;
  }

}
